<template>
    <div class="loader-wrap">
      <div class="loader">
        <span class="content">Loading...</span>
        <div class="progress" v-if="progressDataIsSet()">
          <div class="progress-title">
            <small>{{ percentage }}%</small>
          </div>
          <div class="progress-container">
            <div class="status" :style="{ width: `${percentage}%` }"></div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'Loader',

    props: {
      progress: { type: Object, default: () => {} }
    },

    computed: {
      percentage() {
        return this.progressDataIsSet() && +this.progress.total !== 0
          ? ((+this.progress.loaded / +this.progress.total) * 100).toFixed(0)
          : 0
      },

      loaded() {
        return this.progress.loaded
      },

      total() {
        return this.progress.total
      }
    },

    methods: {
      progressDataIsSet() {
        return this.progress && this.progress.hasOwnProperty('loaded') && this.progress.hasOwnProperty('total')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/styles/mixins";

  $progress-bar-height: 4px;

  .loader-wrap {
    font-size: 2em;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: center center no-repeat;
    background-size: cover;
    z-index: 2;

    .loader {
      padding: 15px 40px;
      border-radius: 25px;
      color: #f7f7f7;
      position: absolute;
      top: 50%;
      left: 50%;
      @include transform-translate(-50%, -50%);
      width: auto;
      height: auto;

      .content {
        text-transform: uppercase;
        font-size: 1em;
        font-weight: 300;
      }
    }
  }

  .progress {
    padding: 5px 0;
    margin: 10px auto;
    border: none;
    max-width: 280px;

    .progress-title {
      text-transform: uppercase;
      font-size: 14px;
      color: #fff;
      text-align: center;
    }

    .progress-container {
      @include border-radius(4px);
      background-color: #e0e0e0;
      width: 100%;
      height: $progress-bar-height;
      margin: 5px 0;
      position: relative;
      overflow: hidden;

      .status {
        @include border-radius(4px);
        height: 100%;
        background: linear-gradient(to right, #444 0%, rgba(68, 68, 68, 0.4) 100%);
        position: absolute;
        top: 0;
        @include transition(all .3s);
      }
    }
  }

  .align-left {
    float: left;
  }

  .align-right {
    float: right;
  }

  .text-center {
    text-align: center;
  }
</style>
